import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

const NEWS_BATCH_SIZE = 5;

const AggregatedNews = ({ news, playerInfo }) => {
  const [visibleCount, setVisibleCount] = useState(NEWS_BATCH_SIZE);
  const containerRef = useRef(null);

  useEffect(() => {
    setVisibleCount(NEWS_BATCH_SIZE); // Reset if news changes
  }, [news]);

  useEffect(() => {
    const handleScroll = () => {
     
      const container = containerRef.current;
      if (!container) return;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
        // Near bottom
        setVisibleCount((prev) => Math.min(prev + NEWS_BATCH_SIZE, news.length));
      }
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [news]);

  const visibleNews = news.slice(0, visibleCount);  
 
  return (
    <div
      className="news-column aggregated"
      ref={containerRef}
      style={{ maxHeight: 500, overflowY: 'auto' }}
    >
      {/* Debug info for UI */}
      {/* Compute leagueFromJSON once and use everywhere */}
      {(() => {
        let leagueFromJSON = '';
        try {
          const info = typeof playerInfo === 'string' ? JSON.parse(playerInfo) : playerInfo;
          if (info && Array.isArray(info.playerInfo)) {
            const sid = info.playerInfo[0]?.sportsID;
            if (sid === 1) leagueFromJSON = 'NFL';
            else if (sid === 2) leagueFromJSON = 'NBA';
            else if (sid === 3) leagueFromJSON = info.playerInfo[0]?.league;
            else if (sid === 5) leagueFromJSON = 'CFB';
            else leagueFromJSON = info.playerInfo[0]?.league;
          } else if (info && typeof info === 'object') {
            leagueFromJSON = info.league;
          }
        } catch { }
        return <>          
          <div className="news-header" style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2, padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <svg fill="#000000" width="40px" height="40px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M 5 5 L 5 9 C 14.93 9 23 17.07 23 27 L 27 27 C 27 14.85 17.15 5 5 5 z M 5 12 L 5 16 C 11.07 16 16 20.93 16 27 L 20 27 C 20 18.72 13.28 12 5 12 z M 8 21 A 3 3 0 0 0 8 27 A 3 3 0 0 0 8 21 z" /></svg>
            <h2 className="aggregated-news-title">
              {(() => {
                const info = typeof playerInfo === 'string' ? JSON.parse(playerInfo) : playerInfo;
                const sid = info?.playerInfo?.[0]?.sportsID;
                if (sid === 3) return 'Latest Team News';
                if (sid === 5) {
                  const teamCity = info?.playerInfo?.[0]?.team_city || '';
                  const teamName = info?.playerInfo?.[0]?.team_name || '';
                  const teamLabel = [teamCity, teamName].filter(Boolean).join(' ') || 'Team';
                  return `Latest ${teamLabel} News`;
                }
                return `Aggregated ${leagueFromJSON || 'NFL'} News`;
              })()}
            </h2>
          </div>
        </>;
      })()}

      {news.length === 0 ? (
        <p>No news found.</p>
      ) : (
        visibleNews.map((item, idx) => (
          // here
          <div className="news-post" key={idx}>
            <div className="news-body">
              <div className="post-header">
                <p>
                  <strong className="username">{item.Source || 'Sports News'}</strong>{' '}
                  <span className="postdate">{item.Updated ? new Date(item.Updated).toLocaleDateString() : ''}</span>
                </p>
                <p className="subheading"><strong>{item.Title}</strong></p>
              </div>
              <div className="post-body">
                {item.ImageUrl && <img className="postimg" src={item.ImageUrl} alt="News" />}
                <p>{item.Content}</p>
                {/* {item.Url && (
                  <p><a href={item.Url} target="_blank" rel="noopener noreferrer">Read more</a></p>
                )} */}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  playerInfo: state.player && state.player.data ? state.player.data : null
});

export default connect(mapStateToProps)(AggregatedNews); 